import { REQUIRED_DATOS_DIRECCION, REQUIRED_FORM_PRINCIPAL, REQUIRED_FORM_STEP0, REQUIRED_FORM_STEP1, REQUIRED_FORM_STEP2, REQUIRED_FORM_STEP2_DOMES, REQUIRED_FORM_STEP2_NATURAL, REQUIRED_FORM_STEP3, REQUIRED_FORM_STEP3_ALTERN, REQUIRED_FORM_STEP3_CONTACT, REQUIRED_FORM_STEP4, VALIDATE_ERRORS_FORMAT } from "./constants";
import { isUndefined } from "lodash-es";
import { emptyJson, getFechaOfDate } from "../../controller/utils";
import { connect, useSelector, useDispatch } from "react-redux";
import { getDynamicOptions } from "./selectors";
import { getFromSession } from "../../controller/session";

function Componet() {
    const dispatch = useDispatch();

}
// export const ComponetController= connect(
//     null,
//     null
// )(Componet);

const mapDispachToProps = (dispatch) => {
    return {
        validateErrors: (value) => dispatch({ type: VALIDATE_ERRORS_FORMAT, value })
    }
}

export const validateDireccion = (values) => {
    let errors = {
        datosdireccion: {}
    };


    if (values) {
        const requiredDatosdireccion = REQUIRED_DATOS_DIRECCION;

        if (values.datosdireccion) {
            requiredDatosdireccion.forEach((field) => {
                if (isUndefined(values.datosdireccion[field.value]) || !values.datosdireccion[field.value]) {
                    errors.datosdireccion[field.value] = "Campo obligatorio";
                }
            });
        }

        // 


    }
    return errors;
}

export const validateStepPrincipal = (values) => {
    let errors = {
        afiliacionEmpresas: {}
    };



    if (values) {
        const requiredStepPrincipal = REQUIRED_FORM_PRINCIPAL;

        if (values.afiliacionEmpresas) {

            requiredStepPrincipal.forEach((field) => {
                if (isUndefined(values.afiliacionEmpresas[field.value]) || !values.afiliacionEmpresas[field.value]) {
                    errors.afiliacionEmpresas[field.value] = "Campo obligatorio";
                }
            });


            if (values.afiliacionEmpresas.numberIdCompanyGes && values.afiliacionEmpresas.typeIdCompanyGes === "NI" && values.afiliacionEmpresas.numberIdCompanyGes.length !== 9) {
                errors.afiliacionEmpresas["numberIdCompanyGes"] = "Longitud debe ser 9 caracteres";
            }

            if (values.afiliacionEmpresas.numberIdCompanyGes && (values.afiliacionEmpresas.typeIdCompanyGes === "PA" || values.afiliacionEmpresas.typeIdCompanyGes === "PE") && values.afiliacionEmpresas.numberIdCompanyGes.length > 16) {
                errors.afiliacionEmpresas["numberIdCompanyGes"] = "Longitud maxima  de 16 caracteres";
            }

            if (values.afiliacionEmpresas.numberIdCompanyGes && values.afiliacionEmpresas.typeIdCompanyGes === "CC" && values.afiliacionEmpresas.numberIdCompanyGes.length < 4) {
                errors.afiliacionEmpresas["numberIdCompanyGes"] = "Longitud mínima 4 caracteres";
            }
            if (values.afiliacionEmpresas.numberIdCompanyGes && values.afiliacionEmpresas.typeIdCompanyGes === "CC" && values.afiliacionEmpresas.numberIdCompanyGes.length > 11) {
                errors.afiliacionEmpresas["numberIdCompanyGes"] = "Longitud maxima 11 caracteres";
            }
            if (values.afiliacionEmpresas.numberIdCompanyGes && values.afiliacionEmpresas.typeIdCompanyGes === "CC" && values.afiliacionEmpresas.numberIdCompanyGes.length === 9) {
                errors.afiliacionEmpresas["numberIdCompanyGes"] = "Número de documento invalido";
            }

            if (values.afiliacionEmpresas.numberIdCompanyGes && values.afiliacionEmpresas.typeIdCompanyGes === "CE" && values.afiliacionEmpresas.numberIdCompanyGes.length < 3) {
                errors.afiliacionEmpresas["numberIdCompanyGes"] = "Longitud mínima 3 caracteres";
            }
            if (values.afiliacionEmpresas.numberIdCompanyGes && values.afiliacionEmpresas.typeIdCompanyGes === "CE" && values.afiliacionEmpresas.numberIdCompanyGes.length > 7) {
                errors.afiliacionEmpresas["numberIdCompanyGes"] = "Longitud maxima de caracteres 7";
            }

            if (values.afiliacionEmpresas.numberIdCompanyGes && values.afiliacionEmpresas.typeIdCompanyGes === "PT" && values.afiliacionEmpresas.numberIdCompanyGes.length < 6) {
                errors.afiliacionEmpresas["numberIdCompanyGes"] = "Longitud mínima 6 caracteres";
            }
            if (values.afiliacionEmpresas.numberIdCompanyGes && values.afiliacionEmpresas.typeIdCompanyGes === "PT" && values.afiliacionEmpresas.numberIdCompanyGes.length > 7) {
                errors.afiliacionEmpresas["numberIdCompanyGes"] = "Longitud maxima de caracteres 7";
            }
        }

    }
    return errors;
};

export const validateStep0 = (values) => {


    let errors = {
        datosinicio: {}
    };

    if (values) {
        const requiredStep0 = REQUIRED_FORM_STEP0;
        const catalog = getFromSession("catalog")


        if (values.datosinicio) {
            requiredStep0.forEach((field) => {
                if (isUndefined(values.datosinicio[field.value]) || !values.datosinicio[field.value]) {
                    errors.datosinicio[field.value] = "Campo obligatorio";
                }
            });
        }

        if (values.datosinicio && values.datosinicio.economicActivityStart && values.datosinicio.economicActivityStart.length > 2) {
            const ban = catalog.economicActivity.find(e => e.label.toUpperCase() === values.datosinicio.economicActivityStart.toUpperCase());
            if (!(ban && ban.value)) {
                errors.datosinicio.economicActivityStart = "Debe seleccionar una actividad";
            }
        }

        if (
            values.datosinicio &&
            values.datosinicio.emailCompanyStart &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                values.datosinicio.emailCompanyStart
            )
        ) {
            errors.datosinicio["emailCompanyStart"] = "Formato de correo electrónico invalido";
        }

        if (
            values.datosinicio &&
            values.datosinicio.emailCompanyCheckStart &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                values.datosinicio.emailCompanyCheckStart
            )
        ) {
            errors.datosinicio["emailCompanyCheckStart"] = "Formato de correo electrónico invalido";
        }

        if (
            values.datosinicio &&
            values.datosinicio.emailCompanyCheckStart && values.datosinicio.emailCompanyStart
            && values.datosinicio.emailCompanyCheckStart !== values.datosinicio.emailCompanyStart) {
            errors.datosinicio["emailCompanyCheckStart"] = "Los correo electrónicos no coiciden";
        }

        if (values.datosinicio && values.datosinicio.checkNumberStart && values.datosinicio.checkNumberStart.length > 20) {
            errors.datosinicio["checkNumberStart"] = "Longitud maxima de caracteres 20";
        }

        if (values.datosinicio && values.datosinicio.smartPhoneRegistro && !/^3[0-9]{9}$/i.test(values.datosinicio.smartPhoneRegistro)) {
            errors.datosinicio["smartPhoneRegistro"] = " el celular debe iniciar en 3 y tener 10 dígitos,";
        }

        if (values.datosinicio && values.datosinicio.smartPhoneRegistro && /^([0-9])\1{9}$/i.test(values.datosinicio.smartPhoneRegistro)) {
            errors.datosinicio["smartPhoneRegistro"] = " el celular no puede tener todos los dígitos iguales,";
        }


    }
    return errors;
};

export const validateStep1 = (values) => {
    let errors = {
        datospersonaladmin: {}
    };
    //   var ban = false

    if (values) {
        const requiredStep1 = REQUIRED_FORM_STEP1;

        if (values.datospersonaladmin) {
            requiredStep1.forEach((field) => {
                if (isUndefined(values.datospersonaladmin[field.value]) || !values.datospersonaladmin[field.value]) {
                    errors.datospersonaladmin[field.value] = "Campo obligatorio";
                }
            });


            if (values.datospersonaladmin.numberIdStaff && values.datospersonaladmin.typeIdStaff === "NI" && values.datospersonaladmin.numberIdStaff.length !== 9) {
                errors.datospersonaladmin["numberIdStaff"] = "Longitud debe ser 9 caracteres";
            }

            if (values.datospersonaladmin.numberIdStaff && (values.datospersonaladmin.typeIdStaff === "PA" || values.datospersonaladmin.typeIdStaff === "PE") && values.datospersonaladmin.numberIdStaff.length > 16) {
                errors.datospersonaladmin["numberIdStaff"] = "Longitud maxima  de 16 caracteres";
            }

            if (values.datospersonaladmin.numberIdStaff && values.datospersonaladmin.typeIdStaff === "CC" && values.datospersonaladmin.numberIdStaff.length < 4) {
                errors.datospersonaladmin["numberIdStaff"] = "Longitud mínima 4 caracteres";
            }
            if (values.datospersonaladmin.numberIdStaff && values.datospersonaladmin.typeIdStaff === "CC" && values.datospersonaladmin.numberIdStaff.length > 11) {
                errors.datospersonaladmin["numberIdStaff"] = "Longitud maxima 11 caracteres";
            }
            if (values.datospersonaladmin.numberIdStaff && values.datospersonaladmin.typeIdStaff === "CC" && values.datospersonaladmin.numberIdStaff.length === 9) {
                errors.datospersonaladmin["numberIdStaff"] = "Número de documento invalido";
            }

            if (values.datospersonaladmin.numberIdStaff && values.datospersonaladmin.typeIdStaff === "CE" && values.datospersonaladmin.numberIdStaff.length < 3) {
                errors.datospersonaladmin["numberIdStaff"] = "Longitud mínima 3 caracteres";
            }
            if (values.datospersonaladmin.numberIdStaff && values.datospersonaladmin.typeIdStaff === "CE" && values.datospersonaladmin.numberIdStaff.length > 7) {
                errors.datospersonaladmin["numberIdStaff"] = "Longitud maxima de caracteres 7";
            }

            if (values.datospersonaladmin.numberIdStaff && values.datospersonaladmin.typeIdStaff === "PT" && values.datospersonaladmin.numberIdStaff.length < 6) {
                errors.datospersonaladmin["numberIdStaff"] = "Longitud mínima 6 caracteres";
            }
            if (values.datospersonaladmin.numberIdStaff && values.datospersonaladmin.typeIdStaff === "PT" && values.datospersonaladmin.numberIdStaff.length > 7) {
                errors.datospersonaladmin["numberIdStaff"] = "Longitud maxima de caracteres 7";
            }

            if (values.datospersonaladmin && values.datospersonaladmin.smartPhoneBossStaff && !/^3[0-9]{9}$/i.test(values.datospersonaladmin.smartPhoneBossStaff)) {
                errors.datospersonaladmin["smartPhoneBossStaff"] = " el celular debe iniciar en 3 y tener 10 dígitos,";
            }

            if (values.datospersonaladmin && values.datospersonaladmin.smartPhoneBossStaff && /^([0-9])\1{9}$/i.test(values.datospersonaladmin.smartPhoneBossStaff)) {
                errors.datospersonaladmin["smartPhoneBossStaff"] = " el celular no puede tener todos los dígitos iguales,";
            }

            let date = new Date();
            let fecha = getFechaOfDate(date)

            if (values.datospersonaladmin && values.datospersonaladmin.birthDateStaff) {
                const fechaSis = Date.parse(getFechaOfDate(values.datospersonaladmin.birthDateStaff));
                if (
                    fechaSis < Date.parse("1900-01-01") ||
                    fechaSis > Date.parse(fecha)
                ) {
                    errors.datospersonaladmin["birthDateStaff"] = "Rango de fecha invalido";
                }
            }

            if (
                values.datospersonaladmin &&
                values.datospersonaladmin.emailStaff &&
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                    values.datospersonaladmin.emailStaff
                )
            ) {
                errors.datospersonaladmin["emailStaff"] = "Formato de correo electrónico invalido";
            }


        }
    }
    return errors;
}

export const validateRelationWorkers = (values) => {
    let errors = {
        datosrelationworkers: {}
    };

    if (values) {
        const requiredStep1 = REQUIRED_FORM_STEP1;

        if (values.datosrelationworkers) {
            requiredStep1.forEach((field) => {
                if (isUndefined(values.datosrelationworkers[field.value]) || !values.datosrelationworkers[field.value]) {
                    errors.datosrelationworkers[field.value] = "Campo obligatorio";
                }
            });

            if (values.datosrelationworkers.numberIdWorker && (values.datosrelationworkers.typeIdWorker === "PA" || values.datosrelationworkers.typeIdWorker === "PE") && values.datosrelationworkers.numberIdWorker.length > 16) {
                errors.datosrelationworkers["numberIdWorker"] = "Longitud maxima  de 16 caracteres";
            }

            if (values.datosrelationworkers.numberIdWorker && values.datosrelationworkers.typeIdWorker === "CC" && values.datosrelationworkers.numberIdWorker.length < 4) {
                errors.datosrelationworkers["numberIdWorker"] = "Longitud mínima 4 caracteres";
            }
            if (values.datosrelationworkers.numberIdWorker && values.datosrelationworkers.typeIdWorker === "CC" && values.datosrelationworkers.numberIdWorker.length > 11) {
                errors.datosrelationworkers["numberIdWorker"] = "Longitud maxima 11 caracteres";
            }
            if (values.datosrelationworkers.numberIdWorker && values.datosrelationworkers.typeIdWorker === "CC" && values.datosrelationworkers.numberIdWorker.length === 9) {
                errors.datosrelationworkers["numberIdWorker"] = "Número de documento invalido";
            }

            if (values.datosrelationworkers.numberIdWorker && values.datosrelationworkers.typeIdWorker === "CE" && values.datosrelationworkers.numberIdWorker.length < 3) {
                errors.datosrelationworkers["numberIdWorker"] = "Longitud mínima 3 caracteres";
            }
            if (values.datosrelationworkers.numberIdWorker && values.datosrelationworkers.typeIdWorker === "CE" && values.datosrelationworkers.numberIdWorker.length > 7) {
                errors.datosrelationworkers["numberIdWorker"] = "Longitud maxima de caracteres 7";
            }

            if (values.datosrelationworkers.numberIdWorker && values.datosrelationworkers.typeIdWorker === "PT" && values.datosrelationworkers.numberIdWorker.length < 6) {
                errors.datosrelationworkers["numberIdWorker"] = "Longitud mínima 6 caracteres";
            }
            if (values.datosrelationworkers.numberIdWorker && values.datosrelationworkers.typeIdWorker === "PT" && values.datosrelationworkers.numberIdWorker.length > 7) {
                errors.datosrelationworkers["numberIdWorker"] = "Longitud maxima de caracteres 7";
            }

            if (values.datosrelationworkers && values.datosrelationworkers.sexoWorker && (values.datosrelationworkers.sexoWorker !== "M" && values.datosrelationworkers.sexoWorker !== "F")) {
                errors.datosrelationworkers["sexoWorker"] = "Sexo invalido";
            }

            if (values.datosrelationworkers && values.datosrelationworkers.basicSalaryWorker && values.datosrelationworkers.basicSalaryWorker.length < 0) {
                errors.datosrelationworkers["basicSalaryWorker"] = "Salario invalido";
            }

            let date = new Date();
            let fecha = getFechaOfDate(date)

            if (values.datosrelationworkers && values.datosrelationworkers.incomeDateWorker) {
                const fechaSis = Date.parse(getFechaOfDate(values.datosrelationworkers.incomeDateWorker));
                if (
                    fechaSis < Date.parse("1900-01-01") ||
                    fechaSis > Date.parse(fecha)
                ) {
                    errors.datosrelationworkers["incomeDateWorker"] = "Rango de fecha invalido";
                }
            }

        }
    }
    return errors;
}

export const validateStep2 = (values) => {
    let errors = {
        datosempleador: {},
        ubicacionempleadorask: {},
    };
    const catalog = getFromSession("catalog")

    if (values) {
        const requiredStep2 = REQUIRED_FORM_STEP2;

        if (values.datosempleador) {
            requiredStep2.forEach((field) => {
                if (isUndefined(values.datosempleador[field.value]) || !values.datosempleador[field.value]) {
                    errors.datosempleador[field.value] = "Campo obligatorio";
                }
            });
        }

        if (
            values.datosempleador &&
            values.datosempleador.emailCompany &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                values.datosempleador.emailCompany
            )
        ) {
            errors.datosempleador["emailCompany"] = "Formato de correo electrónico invalido";
        }



        if (values.datosempleador && values.datosempleador.checkNumber && values.datosempleador.checkNumber.length > 20) {
            errors.datosempleador["checkNumber"] = "Longitud maxima de caracteres 20";
        }

        let date = new Date();
        let fecha = getFechaOfDate(date)

        if (values.datosempleador && values.datosempleador.startOperation) {
            const fechaSis = Date.parse(getFechaOfDate(values.datosempleador.startOperation));
            if (
                fechaSis < Date.parse("1900-01-01") ||
                fechaSis > Date.parse(fecha)
            ) {
                errors.datosempleador["startOperation"] = "Rango de fecha invalido";
            }
        }
        // console.log(values, errors)
        //periodo de aportes debe ser mayor o igual a fehha de operación
        if (values.datosempleador && values.datosempleador.contributionPeriod && values.datosempleador.startOperation) {

            if (Date.parse(getFechaOfDate(values.datosempleador.contributionPeriod)) < Date.parse(getFechaOfDate(values.datosempleador.startOperation))) {
                errors.datosempleador["contributionPeriod"] = "Rango de fecha invalido";
            }
        }

        // if (values.datosempleador && values.datosempleador.contributionPeriod && values.datosempleador.dateCommercialRegitration) {

        //     if (Date.parse(getFechaOfDate(values.datosempleador.contributionPeriod)) < Date.parse(getFechaOfDate(values.datosempleador.dateCommercialRegitration))) {
        //         errors.datosempleador["contributionPeriod"] = "Rango de fecha invalido";
        //     }
        // }

        // if (values.datosempleador && values.datosempleador.startOperation && values.datosempleador.dateCommercialRegitration) {

        //     if (Date.parse(getFechaOfDate(values.datosempleador.startOperation)) < Date.parse(getFechaOfDate(values.datosempleador.dateCommercialRegitration))) {
        //         errors.datosempleador["startOperation"] = "Rango de fecha invalido";
        //     }
        // }


        if (values.ubicacionempleadorask) {
            if (!values.ubicacionempleadorask["empleadorCajaAsk"]) {
                errors.ubicacionempleadorask["empleadorCajaAsk"] = "Campo obligatorio";
            }

            if (values.ubicacionempleadorask["empleadorCajaAsk"] && values.ubicacionempleadorask.empleadorCajaAsk === "1") {
                if (!values.ubicacionempleadorask["empleadorCajaRta"]) {
                    errors.ubicacionempleadorask["empleadorCajaRta"] = "Campo obligatorio";
                }
            }
        }

        if (values.datosempleador && values.datosempleador.economicActivity && values.datosempleador.economicActivity.length > 2) {
            const ban = catalog.economicActivity.find(e => e.label.toUpperCase() === values.datosempleador.economicActivity.toUpperCase());
            if (!(ban && ban.value)) {
                errors.datosempleador.economicActivity = "Debe seleccionar una actividad";
            }
        }


    }
    return errors;
};

export const validateStep2Natural = (values) => {
    let errors = {
        datosempleador: {},
        ubicacionempleadorask: {},
    };
    const catalog = getFromSession("catalog")

    if (values) {
        const requiredStep2 = REQUIRED_FORM_STEP2_NATURAL;

        if (values.datosempleador) {
            requiredStep2.forEach((field) => {
                if (isUndefined(values.datosempleador[field.value]) || !values.datosempleador[field.value]) {
                    errors.datosempleador[field.value] = "Campo obligatorio";
                }
            });
        }

        if (
            values.datosempleador &&
            values.datosempleador.emailCompany &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                values.datosempleador.emailCompany
            )
        ) {
            errors.datosempleador["emailCompany"] = "Formato de correo electrónico invalido";
        }



        if (values.datosempleador && values.datosempleador.checkNumber && values.datosempleador.checkNumber.length > 20) {
            errors.datosempleador["checkNumber"] = "Longitud maxima de caracteres 20";
        }

        let date = new Date();
        let fecha = getFechaOfDate(date)

        if (values.datosempleador && values.datosempleador.startOperation) {
            const fechaSis = Date.parse(getFechaOfDate(values.datosempleador.startOperation));
            if (
                fechaSis < Date.parse("1900-01-01") ||
                fechaSis > Date.parse(fecha)
            ) {
                errors.datosempleador["startOperation"] = "Rango de fecha invalido";
            }
        }
        //periodo de aportes debe ser mayor o igual a fehha de operación
        if (values.datosempleador && values.datosempleador.contributionPeriod && values.datosempleador.startOperation) {

            if (Date.parse(getFechaOfDate(values.datosempleador.contributionPeriod)) < Date.parse(getFechaOfDate(values.datosempleador.startOperation))) {
                errors.datosempleador["contributionPeriod"] = "Rango de fecha invalido";
            }
        }


        if (values.ubicacionempleadorask) {
            if (!values.ubicacionempleadorask["empleadorCajaAsk"]) {
                errors.ubicacionempleadorask["empleadorCajaAsk"] = "Campo obligatorio";
            }

            if (values.ubicacionempleadorask["empleadorCajaAsk"] && values.ubicacionempleadorask.empleadorCajaAsk === "1") {
                if (!values.ubicacionempleadorask["empleadorCajaRta"]) {
                    errors.ubicacionempleadorask["empleadorCajaRta"] = "Campo obligatorio";
                }
            }
        }

        if (values.datosempleador && values.datosempleador.economicActivity && values.datosempleador.economicActivity.length > 2) {
            const ban = catalog.economicActivity.find(e => e.label.toUpperCase() === values.datosempleador.economicActivity.toUpperCase());
            if (!(ban && ban.value)) {
                errors.datosempleador.economicActivity = "Debe seleccionar una actividad";
            }
        }


    }
    return errors;
};

export const validateStep2Dome = (values) => {
    let errors = {
        datosempleador: {},
        ubicacionempleadorask: {},
    };

    const catalog = getFromSession("catalog")

    if (values) {
        const requiredStep2 = REQUIRED_FORM_STEP2_DOMES;

        if (values.datosempleador) {
            requiredStep2.forEach((field) => {
                if (isUndefined(values.datosempleador[field.value]) || !values.datosempleador[field.value]) {
                    errors.datosempleador[field.value] = "Campo obligatorio";
                }
            });
        }

        if (
            values.datosempleador &&
            values.datosempleador.emailCompany &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                values.datosempleador.emailCompany
            )
        ) {
            errors.datosempleador["emailCompany"] = "Formato de correo electrónico invalido";
        }



        if (values.datosempleador && values.datosempleador.checkNumber && values.datosempleador.checkNumber.length > 20) {
            errors.datosempleador["checkNumber"] = "Longitud maxima de caracteres 20";
        }


        if (values.ubicacionempleadorask) {
            if (!values.ubicacionempleadorask["empleadorCajaAsk"]) {
                errors.ubicacionempleadorask["empleadorCajaAsk"] = "Campo obligatorio";
            }

            if (values.ubicacionempleadorask["empleadorCajaAsk"] && values.ubicacionempleadorask.empleadorCajaAsk === "1") {
                if (!values.ubicacionempleadorask["empleadorCajaRta"]) {
                    errors.ubicacionempleadorask["empleadorCajaRta"] = "Campo obligatorio";
                }
            }
        }

        if (values.datosempleador && values.datosempleador.economicActivity && values.datosempleador.economicActivity.length > 2) {
            const ban = catalog.economicActivity.find(e => e.label.toUpperCase() === values.datosempleador.economicActivity.toUpperCase());
            if (!(ban && ban.value)) {
                errors.datosempleador.economicActivity = "Debe seleccionar una actividad";
            }
        }

        let date = new Date();
        let fecha = getFechaOfDate(date)

        if (values.datosempleador && values.datosempleador.startOperation) {
            const fechaSis = Date.parse(getFechaOfDate(values.datosempleador.startOperation));
            if (
                fechaSis < Date.parse("1900-01-01") ||
                fechaSis > Date.parse(fecha)
            ) {
                errors.datosempleador["startOperation"] = "Rango de fecha invalido";
            }
        }
        //periodo de aportes debe ser mayor o igual a fehha de operación
        if (values.datosempleador && values.datosempleador.contributionPeriod && values.datosempleador.startOperation) {

            if (Date.parse(getFechaOfDate(values.datosempleador.contributionPeriod)) < Date.parse(getFechaOfDate(values.datosempleador.startOperation))) {
                errors.datosempleador["contributionPeriod"] = "Rango de fecha invalido";
            }
        }


    }
    return errors;
};

export const validateStep3 = (values) => {
    let errors = {
        ubicacionempleador: {},
        ubicacionempleadorcontact: {},
        ubicacionempleadoraltern: {}
    };
    //   var ban = false

    if (values) {
        const requiredStep3 = REQUIRED_FORM_STEP3;

        if (values.ubicacionempleador) {
            requiredStep3.forEach((field) => {
                if (isUndefined(values.ubicacionempleador[field.value]) || !values.ubicacionempleador[field.value]) {
                    errors.ubicacionempleador[field.value] = "Campo obligatorio";
                }
            });
        }
        let campo = false;
        if (values.ubicacionempleadoraltern) {
            REQUIRED_FORM_STEP3_ALTERN.forEach((field) => {
                if (values.ubicacionempleadoraltern[field.value] && values.ubicacionempleadoraltern[field.value].length > 0) {
                    campo = true;
                }
            });
            if (campo) {
                REQUIRED_FORM_STEP3_ALTERN.forEach((field) => {
                    if (!(values.ubicacionempleadoraltern[field.value] && values.ubicacionempleadoraltern[field.value].length > 0)) {
                        errors.ubicacionempleadoraltern[field.value] = "Campo obligatorio";
                    }
                });
            }
        }

        // if (values.ubicacionempleadorcontact) {
        //     REQUIRED_FORM_STEP3_CONTACT.forEach((field) => {
        //         if (isUndefined(values.ubicacionempleadorcontact[field.value]) || !values.ubicacionempleadorcontact[field.value]) {
        //             errors.ubicacionempleadorcontact[field.value] = "Campo obligatorio";
        //         }
        //     });
        // }

        // if (values.ubicacionempleadorcontact && values.ubicacionempleadorcontact.phoneCompany && values.ubicacionempleadorcontact.phoneCompany.length < 10) {
        //     errors.ubicacionempleadorcontact["phoneCompany"] = "Número de teléfono invalido";
        // }

        // if (values.ubicacionempleadorcontact && values.ubicacionempleadorcontact.phoneCompany && values.ubicacionempleadorcontact.phoneCompany.substring(0, 2) !== "60") {
        //     errors.ubicacionempleadorcontact["phoneCompany"] = "Indicativo de teléfono invalido";
        // }

        // if (values.ubicacionempleadorcontact && values.ubicacionempleadorcontact.phoneCompany && (values.ubicacionempleadorcontact.phoneCompany.substring(0, 3) === "603" || values.ubicacionempleadorcontact.phoneCompany.substring(0, 3) === "609")) {
        //     errors.ubicacionempleadorcontact["phoneCompany"] = "Indicativo de teléfono invalido";
        // }

        if (values.ubicacionempleadorcontact && values.ubicacionempleadorcontact.phoneCompany && !/^60[0-9][0-9]{7}$/i.test(values.ubicacionempleadorcontact.phoneCompany)) {
            errors.ubicacionempleadorcontact["phoneCompany"] = " el teléfono fijo debe iniciar con 60 y tener el formato correcto,";
        }

        // No permitir todos los dígitos iguales después del indicativo
        if (values.ubicacionempleadorcontact && values.ubicacionempleadorcontact.phoneCompany && /^([0-9])\1{6}$/i.test(values.ubicacionempleadorcontact.phoneCompany.slice(-7))) {
            errors.ubicacionempleadorcontact["phoneCompany"] = " el teléfono fijo no puede tener todos los dígitos iguales,";
        }

        if (values.ubicacionempleadorcontact && values.ubicacionempleadorcontact.smartPhoneCompany && values.ubicacionempleadorcontact.smartPhoneCompany.length < 10) {
            errors.ubicacionempleadorcontact["smartPhoneCompany"] = "Número de celular invalido";
        }

        if (values.ubicacionempleadorcontact) {
            if (isUndefined(values.ubicacionempleadorcontact.smartPhoneCompany) || !values.ubicacionempleadorcontact.smartPhoneCompany) {
                errors.ubicacionempleadorcontact["smartPhoneCompany"] = "Campo obligatorio";
            }
        }

        if (values.ubicacionempleadorcontact && values.ubicacionempleadorcontact.smartPhoneCompany && values.ubicacionempleadorcontact.smartPhoneCompany.length < 10) {
            errors.ubicacionempleadorcontact["smartPhoneCompany"] = "Número de celular invalido";
        }

        // if (values.ubicacionempleadorcontact && values.ubicacionempleadorcontact.payrollMonth && values.ubicacionempleadorcontact.payrollMonth.length > 20) {
        //     errors.ubicacionempleadorcontact["payrollMonth"] = "Longitud maxima de caracteres 20";
        // }

        if (
            values.ubicacionempleadorcontact &&
            values.ubicacionempleadorcontact.webSite &&
            !/^(?:www\.)?(?:\w(?:[-\w]{0,61}\w)?\.)*?(\w(?:[-\w]{0,61}\w)?\.(?:\w{2,3}\.)?\w{1,10})(?:[/?#]|$)/i.test(
                //  !/^(?:www\.+)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i.test(
                values.ubicacionempleadorcontact.webSite
            )
        ) {
            errors.ubicacionempleadorcontact["webSite"] = "Formato de pagina web invalido";
        }


    }
    return errors;
};

export const validateStep4 = (values) => {
    let errors = {
        datosrepresentante: {}
    };
    //   var ban = false

    if (values) {
        const requiredStep4 = REQUIRED_FORM_STEP4;

        if (values.datosrepresentante) {
            requiredStep4.forEach((field) => {
                if (isUndefined(values.datosrepresentante[field.value]) || !values.datosrepresentante[field.value]) {
                    errors.datosrepresentante[field.value] = "Campo obligatorio";
                }
            });

            if (values.datosrepresentante.numberId && values.datosrepresentante.typeId === "NI" && values.datosrepresentante.numberId.length !== 9) {
                errors.datosrepresentante["numberId"] = "Longitud debe ser 9 caracteres";
            }

            if (values.datosrepresentante.numberId && (values.datosrepresentante.typeId === "PA" || values.datosrepresentante.typeId === "PE") && values.datosrepresentante.numberId.length > 16) {
                errors.datosrepresentante["numberId"] = "Longitud maxima  de 16 caracteres";
            }

            if (values.datosrepresentante.numberId && values.datosrepresentante.typeId === "CC" && values.datosrepresentante.numberId.length < 4) {
                errors.datosrepresentante["numberId"] = "Longitud mínima 4 caracteres";
            }
            if (values.datosrepresentante.numberId && values.datosrepresentante.typeId === "CC" && values.datosrepresentante.numberId.length > 11) {
                errors.datosrepresentante["numberId"] = "Longitud maxima 11 caracteres";
            }
            if (values.datosrepresentante.numberId && values.datosrepresentante.typeId === "CC" && values.datosrepresentante.numberId.length === 9) {
                errors.datosrepresentante["numberId"] = "Número de documento invalido";
            }

            if (values.datosrepresentante.numberId && values.datosrepresentante.typeId === "CE" && values.datosrepresentante.numberId.length < 3) {
                errors.datosrepresentante["numberId"] = "Longitud mínima 3 caracteres";
            }
            if (values.datosrepresentante.numberId && values.datosrepresentante.typeId === "CE" && values.datosrepresentante.numberId.length > 7) {
                errors.datosrepresentante["numberId"] = "Longitud maxima de caracteres 7";
            }

            if (values.datosrepresentante.numberId && values.datosrepresentante.typeId === "PT" && values.datosrepresentante.numberId.length < 6) {
                errors.datosrepresentante["numberId"] = "Longitud mínima 6 caracteres";
            }
            if (values.datosrepresentante.numberId && values.datosrepresentante.typeId === "PT" && values.datosrepresentante.numberId.length > 7) {
                errors.datosrepresentante["numberId"] = "Longitud maxima de caracteres 7";
            }
        }

        let date = new Date();
        let fecha = getFechaOfDate(date)

        if (values.datosrepresentante && values.datosrepresentante.birthDate) {
            const fechaSis = Date.parse(getFechaOfDate(values.datosrepresentante.birthDate));
            if (
                fechaSis < Date.parse("1900-01-01") ||
                fechaSis > Date.parse(fecha)
            ) {
                errors.datosrepresentante["birthDate"] = "Rango de fecha invalido";
            }
        }

        if (values.datosrepresentante && values.datosrepresentante.smartPhoneBoss && !/^3[0-9]{9}$/i.test(values.datosrepresentante.smartPhoneBoss)) {
            errors.datosrepresentante["smartPhoneBoss"] = " el celular debe iniciar en 3 y tener 10 dígitos,";
        }

        if (values.datosrepresentante && values.datosrepresentante.smartPhoneBoss && /^([0-9])\1{9}$/i.test(values.datosrepresentante.smartPhoneBoss)) {
            errors.datosrepresentante["smartPhoneBoss"] = " el celular no puede tener todos los dígitos iguales,";
        }

        if (values.datosrepresentante && values.datosrepresentante.emailJobBoss
            && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.datosrepresentante.emailJobBoss)
        ) {
            errors.datosrepresentante["emailJobBoss"] = "Formato de correo electrónico invalido";
        }

    }
    return errors;
}


